import Footer from "./Footer";
import Navbar from "./Navbar";

function NewArrivals(){
    return(
        <div>
            <div>
                <Navbar/>
            </div>
            <div>
                <p style={{textAlign:"center"}}>Have a question?We can help.</p>
            </div>
            <hr></hr>
            <div>
                <h1>WOMEN'S NEW ARRIVALS</h1>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BJ602_OR5964_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=480&hei=480" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BJ083_PT1395_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=480&hei=480" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI679_RD5924_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"100px"}}>
                <p>Silk-Cashmere ruffle cardigan sweater</p>
                <h4>INR 18,474</h4>
               </div>
               <div style={{paddingRight:"200px"}}>
               <p>Ruffle halter top in painted block print</p>
                <h4>INR 5,288</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Gwen cupro mini slip dress</p>
                <h4>INR 13,120 - INR 15,797</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BH453_SU9146_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=480&hei=480" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI664_PT1395_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI433_OR5964_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"100px"}}>
                <p>Cashmere cable-knit henely T-shirt</p>
                <h4>INR 17,136</h4>
               </div>
               <div style={{paddingRight:"200px"}}>
               <p>Tie-shoulder tiered mini dress in painterly floral </p>
                <h4>INR 15,797</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>V-neck cotton voile top </p>
                <h4>INR 5,288 - INR 5,958</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"800px",width:"95%", justifyContent:"space-evenly",margin:"center",marginLeft:"40px",marginBottom:"70px"}}>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img4.jpg" alt=""/>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img5.jpg" alt=""/>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BJ576_YL5423_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BK920_YL5433_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BK312_YL5848_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Featherweight cashmere collared short-sleeve sweater</p>
                <h4>INR 17,136</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p> Rounded curb earrings</p>
                <h4>INR 4,619</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Vintage rib crop halter tank</p>
                <h4>INR 2,611</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI662_PT1337_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BH409_BR6712?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BJ596_NA6157_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Swingy V-neck mini dress in tossed floral</p>
                <h4>INR 19,813-INR 21,452</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p> Lina kitten-heel sandals</p>
                <h4>INR 13,320</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Scalloped squareneck pointelle sweater</p>
                <h4>INR 15,797</h4>
               </div>
            </div>
              <div style={{display:"flex",height:"800px",width:"95%", justifyContent:"space-evenly",margin:"center",marginLeft:"40px",marginBottom:"70px"}}>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img0.jpg" alt=""/>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img1.jpg" alt=""/>
              </div>
              <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI618_YD1198_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BL544_EC7253?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI508_PT1341_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Puff- sleeve smocked lines mini dress</p>
                <h4>INR 12,651</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p> Freshwater pearl beaded hoop earrings</p>
                <h4>INR 2,611</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Garden soft guaze top in tossed floral</p>
                <h4>INR 8,903</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI601_WY9087_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BJ726_EE2755_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BK313_PK5775_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Afternoon dress in tossed floral</p>
                <h4>INR 15,358</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p>Sedona basket bag in leather</p>
                <h4>INR 19,810</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Tissue mockneck tank</p>
                <h4>INR 2,611</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"800px",width:"95%", justifyContent:"space-evenly",margin:"center",marginLeft:"40px",marginBottom:"70px"}}>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img6.jpg" alt=""/>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img7.jpg" alt=""/>
              </div>
              <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BG324_GR0216_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI309_EC7253?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BL704_YL5455_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Drapey long Parke blazer in cupro </p>
                <h4>INR 33,200</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p>Pearl pendant rope necklace</p>
                <h4>INR 6,426</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Broken in Jersey daisy T-shirt</p>
                <h4>INR 5,228</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BH755_OR6286_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI237_GR0216_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BH908_WT0002_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Short sleeve collared pointelle sweater</p>
                <h4>INR 7,966</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p>Drapey cupro trouser</p>
                <h4>INR 21,152</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Cap sleeve vintage rib T-shirt</p>
                <h4>INR 5,288</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"800px",width:"95%", justifyContent:"space-evenly",margin:"center",marginLeft:"40px",marginBottom:"70px"}}>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img8.jpg" alt=""/>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img9.jpg" alt=""/>
              </div>
              <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/H5807_BL7133_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BE770_BL7133?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BL830_BL7505_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>5" stretch chino short</p>
                <h4>INR 5,228</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p>Zoe ballet flats in suede</p>
                <h4>INR 11,982-INR 12,919</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Broken-in jersey puff sleeve T-shirt</p>
                <h4>INR 5,288</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BL005_PR5683_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BK696_DM6333_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI679_PR5683_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Ruffle Tie-neck Top</p>
                <h4>INR 9,304</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p>9" vintage slim-straight jean in Poppy wash</p>
                <h4>INR 18,474</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Gwen cupro mini slip dress</p>
                <h4>INR 15,797</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"800px",width:"95%", justifyContent:"space-evenly",margin:"center",marginLeft:"40px",marginBottom:"70px"}}>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img10.jpg" alt=""/>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img11.jpg" alt=""/>
              </div>
              <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI670_WT0002_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BL706_PT1350_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BH808_GR7014_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Cotton poplin apron dress with convertible straps</p>
                <h4>INR 19,813</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p>Halter top in Ratti</p>
                <h4>INR 5,288-INR 7,966</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Gathered pull-on pant in linen</p>
                <h4>INR 14,726</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI427_PT1350_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/AY671_GR7014_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI689_PT1350_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Classic-fit cotton poplin popover top in Ratti</p>
                <h4>INR 14,659</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p>Smocked puff-sleeve linen top  </p>
                <h4>INR 11,982</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Anguilla halter dress in Ratti </p>
                <h4>INR 49,264</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"800px",width:"95%", justifyContent:"space-evenly",margin:"center",marginLeft:"40px",marginBottom:"70px"}}>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img12.jpg" alt=""/>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img13.jpg" alt=""/>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI423_PT1365_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/AY545_GR0086_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI431_GR6974_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Organic cotton ruffle-waist tank in Liberty</p>
                <h4>INR 4,069</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p>Zoe ballet mules in suede </p>
                <h4>INR 11,982</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>V-neck soft guaze popover</p>
                <h4>INR 14,726</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI669_PT1365_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BK310_GR8247_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI419_PT1365_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Afternoon dress in Liberty</p>
                <h4>INR 22,490</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Broken-in Jersey button-front top</p>
                <h4>INR 5,288</h4>
               </div>
               <div style={{paddingRight:"50px"}}>
               <p>Organic cotton classi-fit popover in Liberty</p>
                <h4>INR 14,725</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"800px",width:"95%", justifyContent:"space-evenly",margin:"center",marginLeft:"40px",marginBottom:"70px"}}>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img14.jpg" alt=""/>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img15.jpg" alt=""/>
              </div>
              <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI275_RD5712_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI660_BK0001_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI663_RD5924_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Cross-back knit mini dress</p>
                <h4>INR 15,797</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p>Strappy linen-cupro dress</p>
                <h4>INR 22,490</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Tie shoulder tiered mini dress</p>
                <h4>INR 13,120</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI672_OR5678_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BK447_PK6432_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BJ579_OR0034_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Tie-shoulder cotton voile tiered dress</p>
                <h4>INR 22,490</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
                <p>Broken-in Jersey tulip relaxed T-shirt</p>
                <h4>INR 4,619</h4>
               </div>
               <div style={{paddingRight:"50px"}}>
                <p>One-shoulder stretch sweater</p>
                <h4>INR 9,304</h4>
               </div>
            </div> 
            <div style={{display:"flex",height:"800px",width:"95%", justifyContent:"space-evenly",margin:"center",marginLeft:"40px",marginBottom:"70px"}}>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img16.jpg" alt=""/>
               <img style={{width:"50%"}} src="https://www.jcrew.com/brand_creative/2022/202207-Jul/w_newarrivals/v2/2022jul_0628_w_na_img17.jpg" alt=""/>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BH919_BK0001_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BH415_EE2515?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BJ979_BR6302_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Cross-back knit mini dress</p>
                <h4>INR 15,797</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p>Strappy linen-cupro dress</p>
                <h4>INR 22,490</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Tie shoulder tiered mini dress</p>
                <h4>INR 13,120</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BJ171_BK0001_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BH455_NA6167_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BI750_BK0001_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Tie-shoulder cotton voile tiered dress</p>
                <h4>INR 22,490</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
                <p>Broken-in Jersey tulip relaxed T-shirt</p>
                <h4>INR 4,619</h4>
               </div>
               <div style={{paddingRight:"50px"}}>
                <p>One-shoulder stretch sweater</p>
                <h4>INR 9,304</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BH454_NA6549_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BK311_BK0001_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BH460_NA6167_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Cross-back knit mini dress</p>
                <h4>INR 15,797</h4>
               </div>
               <div style={{paddingRight:"250px"}}>
               <p>Strappy linen-cupro dress</p>
                <h4>INR 22,490</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
               <p>Tie shoulder tiered mini dress</p>
                <h4>INR 13,120</h4>
               </div>
            </div>
            <div style={{display:"flex",height:"450px",width:"100%",justifyContent:"space-evenly"}}>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BJ599_SU8014?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BH458_SU9355_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
                <img style={{height:"100%",width:"30%"}} src="https://www.jcrew.com/s7-img-facade/BF450_NA6445_m?fmt=jpeg&qlt=90,0&resMode=sharp&op_usm=.1,0,0,0&crop=0,0,0,0&wid=309&hei=309" alt=""/>
            </div>
            <div style={{display:"flex",height:"100px",width:"100%",justifyContent:"space-evenly"}}>
               <div style={{paddingRight:"150px"}}>
                <p>Tie-shoulder cotton voile tiered dress</p>
                <h4>INR 22,490</h4>
               </div>
               <div style={{paddingRight:"100px"}}>
                <p>Broken-in Jersey tulip relaxed T-shirt</p>
                <h4>INR 4,619</h4>
               </div>
               <div style={{paddingRight:"50px"}}>
                <p>One-shoulder stretch sweater</p>
                <h4>INR 9,304</h4>
               </div>
            </div>
            <div>
                <Footer/>
            </div>
    </div>
    )
}
export default NewArrivals;